const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/about",
    exact: true,
    component: "About",
  },
  {
    path: "/mission",
    exact: true,
    component: "Mission",
  },
  {
    path: "/product",
    exact: true,
    component: "Product",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
  {
    path: "/features",
    exact: true,
    component: "Features",
  },
  {
    path: "/pricing",
    exact: true,
    component: "Pricing",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
  {
    path: "/terms",
    exact: true,
    component: "Terms",
  },
  {
    path: "/security",
    exact: true,
    component: "Security",
  },
  {
    path: "/help",
    exact: true,
    component: "HelpCenter",
  },
  {
    path: "/faq",
    exact: true,
    component: "FAQ",
  },
  {
    path: "/status",
    exact: true,
    component: "Status",
  },
  {
    path: "*",
    exact: false,
    component: "NotFound",
  },
];

export default routes;
